
export async function initiateDeviceAuthFlow(clientID: string, scope: string) {
    try {
        const response = await fetch('https://identity-dev.stoneageconnect.com/realms/master/protocol/openid-connect/auth/device', { 
            method: 'POST',

            headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            //'Content-Type': 'application/json; charset=UTF-8',
            'Accept': '*/*',
            'Connection': 'keep-alive',
            },
            
            body: new URLSearchParams({
              client_id: clientID,
              scope: scope,
            }).toString(),
            //body: JSON.stringify({
            //  client_id: clientID,
            //  scope: scope,
            //}),
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(`Status: ${response.status} | Error: ${data.error} | Error Description: ${data.error_description}`);
        }
        return data;

    } catch (err: any) {
        console.log('initiateDeviceAuthFlow Error: ', err.message);
        throw err;
    } finally {
    }      
}

export async function getAccessToken(grantType: string, deviceCode: string, clientID: string) {
    try {
        const tsStart: number = Math.floor(Date.now() / 1000);
        while(true) {
            const response = await fetch('https://identity-dev.stoneageconnect.com/realms/master/protocol/openid-connect/token', { 
                method: 'POST',
                headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': '*/*',
                'Connection': 'keep-alive',
                },

                body: new URLSearchParams({
                  grant_type: grantType,
                  device_code: deviceCode,
                  client_id: clientID
                }).toString()
            });

            const data = await response.json();
            if (!response.ok) {
                // Check if timeout expired
                const tsNow: number = Math.floor(Date.now() / 1000);
                if (tsNow - tsStart > 600) {
                    throw new Error('Device was not authorized within the allowed timeframe (10 min).');
                }
                // Delay before retrying
                await sleep(5000); // Delay for 5 second
            } else {
                return data;
            }
        }

    } catch (err: any) {
        console.log('getAccessToken Error: ', err.message);
    } finally {
    }      
}

async function sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export async function refreshAccessToken(grantType: string, clientID: string, refreshToken: string) {
    try {
        const response = await fetch('https://identity-dev.stoneageconnect.com/realms/master/protocol/openid-connect/token', { 
            method: 'POST',
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': '*/*',
            'Connection': 'keep-alive',
            },
            body: new URLSearchParams({
              grant_type: grantType,
              client_id: clientID,
              refresh_token: refreshToken
            }).toString()
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(`Status: ${response.status} | Error: ${data.error} | Error Description: ${data.error_description}`);
        }
        return data;

    } catch (err: any) {
        console.log('refreshAccessToken Error: ', err.message);
    } finally {
    }      
}

// ***************************************************************************************
// Test generic functions
// ***************************************************************************************

export function fetchData1(): Promise<string> {
  // Simulate an asynchronous operation
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve("Data from function 1");
    }, 1000);
  });
}

export async function fetchData2(id: number): Promise<object> {
  // Simulate another asynchronous operation
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ id: id, message: "Data from function 2" });
    }, 1500);
  });
}

export async function processData(input: string): Promise<boolean> {
  // Simulate a third asynchronous operation
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log(`Processing: ${input}`);
      resolve(true);
    }, 500);
  });
}